export const CATEGORY_MAIN = 'CATEGORY_MAIN';
export const CATEGORY_SUB = 'CATEGORY_SUB';
export const CATEGORY_ERROR = 'CATEGORY_ERROR';
